import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { TableRow, TableCell, Tooltip, IconButton, Checkbox } from "@material-ui/core";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import moment from "moment";
import { regexConstants } from "../../../../constants/regEx";
import { permissionCheckFnforCamo, Comma_format } from "../../../../utils";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";

const EngineModuleList = ({ item, toggleModalFn, toggleDelteModalFn, toggleBulkOps, bulk }) => {
    const [lessMore, setLessMore] = useState({});
    const toggleLessMore = (lessMr) => {
        setLessMore({
            ...lessMore,
            [lessMr]: !lessMore[lessMr]
        });
    }
    const lessMoreFn = (name, lessMr) => {
        return <>
            {name && name?.length > 35 ? (
                <>
                    {lessMore[lessMr] ?
                        (<> {name} <span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
                        :
                        (<>{name.substring(0, 35)} <span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
                    }
                </>
            ) : name || '--'
            }
        </>
    }

    let timezone = moment().format()
    const timestamp = Math.floor(Date.now() / 1000);
    const softTimeurl = `audit/camo/enginemodule/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`

    return (
        <>
            <TableRow hover tabIndex={-1} style={{ cursor: "pointer" }} className="engine-module-table" >
                <TableCell>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) || window?.location?.search.includes('archived-assets') ? null : (<Checkbox
                            color="primary"
                            size="small"
                            checked={bulk?.ids?.find(items => items?.id === item?.id) ? true : false}
                            onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                        />)}
                        {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) || window?.location?.search.includes('archived-assets') ? null : (
                            <Tooltip title="Edit" arrow placement="top">
                                <CreateOutlinedIcon color="primary" onClick={toggleModalFn} />
                            </Tooltip>
                        )}
                        {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) || window?.location?.search.includes('archived-assets') ? null : (
                            <Tooltip title="Delete" arrow placement="top">
                                <DeleteOutlinedIcon color="secondary" onClick={toggleDelteModalFn} />
                            </Tooltip>
                        )}
                        <RevisionHistory buttonType={true} url={softTimeurl} source={true} />
                    </div>
                </TableCell>
                <TableCell>{item?.module_name || "--"}</TableCell>
                <TableCell>{item?.section || "--"}</TableCell>
                <TableCell>{lessMoreFn(item?.description, "description")} </TableCell>
                <TableCell>{item?.tsn ? regexConstants.alphanumespcespclchar.test(item?.tsn) ? item?.tsn : Comma_format(parseFloat(item?.tsn)) : "--"}</TableCell>
                <TableCell>{item?.csn ? regexConstants.alphanumespcespclchar.test(item?.csn) ? item?.csn : Comma_format(parseInt(item?.csn)) : "--"}</TableCell>
                <TableCell>{item?.tspr ? regexConstants.alphanumespcespclchar.test(item?.tspr) ? item?.tspr : Comma_format(parseFloat(item?.tspr)) : "--"}</TableCell>
                <TableCell>{item?.cspr ? regexConstants.alphanumespcespclchar.test(item?.cspr) ? item?.cspr : Comma_format(parseInt(item?.cspr)) : "--"}</TableCell>
                <TableCell> {lessMoreFn(item?.remarks, "remarks")} </TableCell>
            </TableRow>
        </>
    );
};
export default withRouter(EngineModuleList);